import React from "react";
import Avatar from 'react-avatar';
import jwt from 'jwt-decode'
// reactstrap components
import {
  Col,
  Row,
  ListGroup,
  ListGroupItem,
} from "reactstrap";
import { Scrollbars } from 'react-custom-scrollbars';
import LoginService from '../../services/api/Login'
import UserService from '../../services/api/User'
import { EXPIRE_SIGNIN_AUTH_TOKEN, SIGNIN_AUTH_TOKEN, ACCESS_TOKEN } from '../../settings/shared/constants';
import { getRandomRolor } from '../../settings/shared/commonMethod'
// core components
import df from "assets/img/df.png";
import { toast } from 'react-toastify';



class chooseTenant extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      totalTenants: 0,
      tenantList: [],
      emailId: "",
      timer: {}
    };
  }

  componentDidMount() {
    if (sessionStorage.getItem(SIGNIN_AUTH_TOKEN) === null) {
      this.LogOutsession();
    }

    const timerObj = setTimeout(() => {  // deactivate the session and move to login page
      this.LogOutsession();
    }, EXPIRE_SIGNIN_AUTH_TOKEN);
    this.setState({
      timer: timerObj
    })


    document.body.classList.add("tenant-page");
    var spans = document.getElementsByClassName('full-page section-image');
    var i;
    for (i = 0; i < spans.length; i++) {
      spans[i].classList.add("df-bg-white");
    }
    let tenants = this.props.location.state.tenantList;
    this.GetAllTenants(tenants);
  }


  // Get all tenants
  GetAllTenants = (tenants) => {
    if (this.props.location.state.tenantList !== undefined) {
      if (tenants !== undefined || tenants !== null) {
        this.setState({
          tenantList: tenants,
          emailId: this.props.location.state.email
        })
      }
    } else {
      this.props.history.push('/auth/login-page');
    }
  }


  // To post Tenant data
  proceedWithTenant = (data) => {
    if (data !== undefined && this.props.location.state.email !== undefined && sessionStorage.getItem(SIGNIN_AUTH_TOKEN) !== null) {
      localStorage.setItem("accountLogo" ,data.accountLogo);
      localStorage.setItem("accountName" ,data.accountName);
      let tenantData = {
        email: this.props.location.state.email.toLowerCase(),
        authToken: sessionStorage.getItem(SIGNIN_AUTH_TOKEN),
        accountId: data.accountID
      }  
      LoginService.auth_tenant(tenantData)
        .then((response) => {
          var decoded;
          if (response.status === 'SUCCESS') {
            decoded = jwt(response.token);
            localStorage.setItem(ACCESS_TOKEN, response.token);
            localStorage.setItem("Uid", decoded.id);
            sessionStorage.clear(); // here clear the session storage for auth signin 
            clearTimeout(this.state.timer); // clear time out session after succes authentication
            this.getUserRole();
          } else if (response.token !== null) {
            toast.error(response.errorMessage);
            localStorage.setItem(ACCESS_TOKEN, response.token);
            decoded = jwt(response.token);
            localStorage.setItem("Uid", decoded.id);
            sessionStorage.clear(); // here clear the session storage for auth signin 
            clearTimeout(this.state.timer); // clear time out session after succes authentication
            this.props.history.push('/auth/updatePassword');
          }else {
            toast.error(response.errorMessage);
          }
        })
    }
  }

  getUserRole = () => {
    UserService.getuserRole(localStorage.getItem('Uid'))
      .then((response) => {
        if (response.status === 'SUCCESS') {
          if (response.userDTOS.length > 0) {
            localStorage.setItem("lastLogin", response.userDTOS[0].lastLogin);
            localStorage.setItem("role", response.userDTOS[0].role);
            this.props.history.push('/auth/menu-settings');
          }
        } else {
          toast.error(response.errorMessage);
        }
      });
  }

  LogOutsession = () => {
    sessionStorage.clear();
    localStorage.clear();
    this.props.history.push('/auth/login-page');
  }
  render() {
    return (
      <div className="content df-bg-white">
        <Row>
          <Col xs="12" className="d-flex justify-content-center">
            <div className="divbox" >
              <div className="justify-content-center d-flex align-items-center">
                <img src={df} width="60" height="60" alt="logo" /> &nbsp;&nbsp;

              </div>

              <div className="text-center">
                <span className="headingText df-text-primary ">DecisionFacts</span>
                <p className="listTitle">Choose a account below to get back to working with your team.</p>
              </div>

              <ListGroup>

                <ListGroupItem>
                  <Row>
                    <Col xs="6">
                      <span title={this.state.emailId} className="headingDescription overflowStyle">accounts for <span className="font-weight-bold text-primary">{this.state.emailId}</span></span>
                    </Col>
                    <Col xs="6" className="">
                      <span className="spanTotal text-primary">You have&nbsp;<span className="font-weight-bold">{this.state.tenantList.length}</span><span>&nbsp;accounts</span></span>
                    </Col>
                  </Row>
                </ListGroupItem>

                <Scrollbars autoHeight autoHeightMin={230}>

                  {this.state.tenantList.length !== 0 ? this.state.tenantList.map((item, index) => (<ListGroupItem key={index}>
                    <Row onClick={e => this.proceedWithTenant(item)} className="actionicon">
                      <Col xs="2" className="d-flex align-items-end ">

                        {item.accountLogo === null ? <Avatar color={getRandomRolor()} className="ml-1"
                          name={item.accountName}
                          size="36" textSizeRatio={2} /> : <img src={item.accountLogo} className="fit-image" width={36} height={36} alt="logo"></img>}
                      </Col>
                      <Col xs="9" className="mt-2">
                        <span className="font-weight-bold listTitle ml-1">{item.accountName}</span> <br />
                        {/* <Row className="pt-1">
                          <Col xs="6">
                            {this.state.tenantList[index].users.map((itemUser, indexUser) => (
                              itemUser.photoURL !== null ? <img key={indexUser} width={25} height={25} className={indexUser !== 0 ? "ml-2 imageRound" : "imageRound"} src={itemUser.photoURL} alt={itemUser.firstName + "  " + itemUser.lastName}></img> :
                                <Avatar key={indexUser} color={getRandomRolor()} className={indexUser !== 0 ? "ml-1" : ""}
                                  name={itemUser.firstName + " " + itemUser.lastName}
                                  round={true} textSizeRatio={2}
                                  size="25" />
                            ))}
                          </Col>
                        </Row> */}
                      </Col>
                      <Col xs="1" className="d-flex align-items-center actionicon">
                        <i className="fas fa-arrow-right"></i>
                      </Col>
                    </Row>
                  </ListGroupItem>)) : ""}
                </Scrollbars>

              </ListGroup>
              <div className="text-center">
                <button type="button" onClick={e => this.LogOutsession()} className="btn btn-outline-primary btn-sm actionicon">Cancel</button>
              </div>

            </div>
          </Col>
        </Row>

      </div>
    );
  }
}

export default chooseTenant;